import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState, useMemo } from "preact/hooks";

export default () => {
    const { response: { products } } = useAppState();
    const groupSet = new Set([])
    const [ swatchData, setSwatchData ] = useState([]);

    useEffect(() => {  
        if(!products?.hits || products.hits?.length < 1) return;

        var tagsToFetch;

        products?.hits?.map((product) =>{
            var groupTag = product?.tags1?.find(tag => tag?.includes('YGroup')||tag?.includes('Ygroup')) || null;
            groupSet.add(groupTag);
            let masterArray = Array.from(groupSet);
            tagsToFetch = masterArray;
        });

        const fetchRelatedProducts = async (master) => {
            let query = `
                query {
                    products(limit: 300, filter: {tags1: ${JSON.stringify(master)}}) {
                        products{
                          productId
                          availability
                          alternateImageUrls
                          name
                          tags1
                          url
                          imageUrl
                          price
                          listPrice
                          skus {
                              name
                              id
                              availability
                              attributes {
                                  key
                                  value
                              }
                          }
                        }
                    }
                }`;
            const response = await fetch('https://api.nosto.com/v1/graphql', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/graphql',
                    'Authorization': 'Basic ' + btoa(":" + "y4G0FMVcgkjjtm6AqmDztohLO5UMXqMiHmdkGjQyvqnlzmiKQ8FWEP7jJ74Gmo4w")
                }),
                mode: 'cors',
                body: query
            })

            if (response?.status === 200){
                const data = await response.json()
                const fetchedResults = data?.data?.products?.products || []
                return fetchedResults;
            }
        }
        if(groupSet?.length < 1) return
        fetchRelatedProducts(tagsToFetch).then(data => {
            const filteredData = data.filter(product => product.availability != "Invisible")
            setSwatchData(filteredData);
        })

    }, [ products ])

    return { swatchData }

}